import {Injectable} from '@angular/core';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import {AuthService} from '../../../services/user/auth.service';
import {CalendarTranslate} from '../../../models/calendarTranslate.model';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import {el} from "@angular/platform-browser/testing/src/browser_util";
import * as moment from 'moment';


@Injectable()
export class CalendarTranslateService {

  public pcalendarTranslate: CalendarTranslate;
  private _pCalendar: ReplaySubject<CalendarTranslate>;

  private calendars = {

   it: <CalendarTranslate> {
    firstDayOfWeek: 1,
    dayNames: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
    dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
    dayNamesMin: ["Do","Lu","Ma","Me","Gi","Ve","Sa"],
    monthNames: [ "Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre" ],
    monthNamesShort: [ "Gen", "Feb", "Mar", "Apr", "Mag", "Giu","Lug", "Ago", "Set", "Ott", "Nov", "Dic" ],
    dateFormat: "dd/mm/yy",
    dateFormatFilter: "dd/MM/yyyy",
    dateFormatHour: "dd/MM/yyyy HH:mm:ss",
    placeholderFormat:"dd/MM/yyyy",
    clear: 'Pulisci'
  },
  en: <CalendarTranslate> {
    firstDayOfWeek: 0,
    dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["Su","Mo","Tu","We","Th","Fr","Sa"],
    monthNames: [ "January","February","March","April","May","June","July","August","September","October","November","December"],
    monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ],
    dateFormat: "mm/dd/yy",
    dateFormatFilter: "MM/dd/yyyy",
    dateFormatHour: "MM/dd/yyyy HH:mm:ss",
    placeholderFormat:"dd/MM/yyyy",
    clear: 'Clear'
  }


  }


  constructor(private translate: TranslateService, private srvAuth: AuthService)
  {
    this._pCalendar = new ReplaySubject(1);

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {

      this.refreshLang();
    });

    this.refreshLang();
  }
  refreshLang() {

    if (this.srvAuth.sessionHelper == null || this.srvAuth.sessionHelper.selectedLanguage == null) {
      return;
    }

    //this.translate.getTranslation(this.srvAuth.sessionHelper.selectedLanguage).subscribe(data => {
    this.translate.get("pcalendar").subscribe(data => {

      const keys = ['dayNames', 'dayNamesShort', 'dayNamesMin', 'monthNames', 'monthNamesShort'];

      // fixme    in determinate (e sconosciute) condizioni l'oggetto data.pcalendar non risulta essere definito mandando in blocco tutto.
      // fixme    sarebbe opportuno verificare quali sono queste condizioni ed eventualmente applicare una fix più efficace di questo if
      // fixme    (Ernesto M. I3)

      //FIXATO (Federico Cinque)

      //fix me temp
      // COMMENTATO PER FIXARE BUG SEGNALATO DA SONARQUBE
      /* data = undefined
      if (data !== undefined) {
        console.log('new data', data)
        // keys.forEach( key => {
        //   data[key] = JSON.parse(data[key]);
        // });

        this.pcalendarTranslate = data;
        this._pCalendar.next(data);

      } else {
        this.pcalendarTranslate = this.calendars[this.srvAuth.sessionHelper.selectedLanguage.toLowerCase()]
        this._pCalendar.next(this.calendars[this.srvAuth.sessionHelper.selectedLanguage.toLowerCase()]);
      } */
      this.pcalendarTranslate = this.calendars[this.srvAuth.sessionHelper.selectedLanguage.toLowerCase()];
      this._pCalendar.next(this.calendars[this.srvAuth.sessionHelper.selectedLanguage.toLowerCase()]);
    });
  }

  get pCalendar() {
    return this._pCalendar.asObservable();
  }

  /**
   * Verifica formato data per evitare errori nel date pipe
   */
   checkDateFormat(date: string|Date) {
     if (typeof date === 'string') {
       // Sia dd/MM/yyyy che MM/dd/yyyy
       const dateRegex = new RegExp(/^\d{2}[\/]\d{2}[\/]\d{4}$/);
       return dateRegex.test(date);
     }
     return false;
   }

}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/services/calendarTranslate.service.ts